"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4869],{

/***/ 14869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10.464h4.334v2.158c.624-1.241 2.224-2.357 4.629-2.357 4.61 0 5.704 2.471 5.704 7.005v8.397H21v-7.364c0-2.582-.624-4.038-2.213-4.038-2.204 0-3.12 1.569-3.12 4.037v7.365h-4.666V10.464ZM2.999 25.468h4.667V10.265H2.998v15.203Zm5.336-20.16a2.952 2.952 0 0 1-.879 2.103 3.022 3.022 0 0 1-4.244.001 2.973 2.973 0 0 1-.878-2.104c0-.79.315-1.545.879-2.103a3.018 3.018 0 0 1 4.243 0c.563.558.879 1.314.879 2.103Z",
    fill: "#fff"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgLinkedIn);

/***/ })

}]);